import HeaderSubSection from "../../components/HeaderSubSection/index.vue";
// import articleModal from "../../components/articleModal/index.vue";
import articlesSection from "../../components/articlesBySearchSection/index.vue";
export default {
  name: "articlesSearchPage",
  components: {
    HeaderSubSection,
    // articleModal,
    articlesSection,
  },
};
